<template>
  <div class="page-not-found">
    <div class="pnf-body">
      <h1>ไม่พบหน้าที่ต้องการ</h1>

      <material-button class="pnfb-button" @clickButton="$router.push('/')">
        กลับไปหน้าแรก
      </material-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageNotFound",
  components: {},
  computed: {
    isDisabled: function () {
      return true;
    },
  },
};
</script>

<style scoped>
.page-not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.pnf-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 352px;
  text-align: center;
  margin-bottom: 32px;
  margin-top: 50px;

  color: red;
}
.pnfb-button {
  padding: 0px 20px;
  margin-bottom: 14px;
  margin-top: 35px;
}

/*size  >768px */
@media only screen and (min-width: 769px) {
}
</style>
